module.exports = __webpack_public_path__ + "img/pig-all-m.9469b10f.webp";